/**
 *
 * @author: Dumitrana Alinus <alinus@wooter.co>
 * @component: HideOnNotification
 * @date: 05.02.2021
 * @time: 14:19
 */
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useApp } from '@packages/hooks/useApp';
import { NotificationServiceProvider } from '@packages/notifications';
import { NotificationEvents } from '@packages/notifications/lib/NotificationServiceProvider';
import { useEffect, useState } from 'react';

const useStyles = makeStyles(() => ({
    '@global': {
        '#hubspot-messages-iframe-container': {
            display: 'none',
        },
    },
}));

function GlobalStyle() {
    useStyles();
    return null;
}

export function HideOnNotification() {
    const notifyService = useApp(NotificationServiceProvider);
    const [opened, setOpened] = useState(0);

    useEffect(() => {
        notifyService.on(NotificationEvents.CHANGE, () => setOpened(notifyService.countOpened()));
    }, []);

    return opened > 0 ? <GlobalStyle /> : null;
}

export default HideOnNotification;
